import React from 'react';
import { connect } from 'react-redux';

import { Route } from 'react-router-dom';
import loadable from 'react-loadable';
import Header from 'components/Header';
import Sidenav from 'components/Sidenav';
import Footer from 'components/Footer';
import Customizer from 'components/Customizer';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import Dashboard from '../routes/dashboard/'
import Rooms from '../routes/rooms/Rooms';
import ConsolidatedRooms from '../routes/rooms/ConsolidatedRooms';
import RoomControl from '../routes/rooms/RoomControl';
import TelephoneDirectory from '../routes/Telephone/TelephoneDirectory';
import WifiManagement from '../routes/Wifi/WifiManagement';
import FoodMenu from '../routes/food-menu/FoodMenu';
import Lock from '../routes/move-locks/MoveLock';
import ServiceRequests from '../routes/services/ServiceRequests';
import IntrusionAlets from '../routes/services/IntrusionAlerts';
import ManageServices from '../routes/services/ManageServices';
import ManageServiceButtons from '../routes/services/ManageServiceButtons'
import Users from '../routes/users/Users';
import SmartLockCards from '../routes/smart-lock-cards/SmartLockCards';
import PowerRoute from '../routes/power/Power';
import RoomStats from '../routes/stats/RoomStats';
import LockStats from '../routes/stats/LockStats';
import DeviceConfigure from '../routes/rooms/DeviceConfigure';
import LockPair from '../routes/rooms/LockPair';
import Promotions from '../routes/promotions/Promotions';
import Schedule from '../routes/schedule/Schedule';
import Settings from '../routes/settings/Settings';
import ActionsPost from '../routes/rooms/ActionsPost';
import APPCONFIG from 'constants/Config';
// import Chart from '../routes/chart/'
// import ECommerce from '../routes/ecommerce/'
// import Form from '../routes/form/'
// import Page from '../routes/page/'
// import PageLayout from '../routes/page-layout/'
// import Table from '../routes/table/'
// import UI from '../routes/ui/'

//store
import { store } from '../../../stores/configureStore';

//action
import { toggleLoader } from '../../../actions';
import FeedbackTemplatesCreate from '../routes/feedback/FeedbackTemplatesCreate';
import FeedbackTemplatesView from '../routes/feedback/FeedbackTemplatesView';
import FeedbackResponse from '../routes/feedback/FeedbackResponse';

import GenerateToken from '../routes/integration/GenerateToken';
import MessageService from '../../../services/MessageService'; let _mqtt = MessageService;
import DataService from '../../../services/DataService'; let ds = DataService;
import LocalStorageService from "../../../services/LocalStorageService";
 var ls = LocalStorageService;

function LoadingComponent() {
  return <div></div>;
}

let AsyncChart = loadable({
  loader: () => import('../routes/chart/'),
  loading: LoadingComponent
})
let AsyncECommerce = loadable({
  loader: () => import('../routes/ecommerce/'),
  loading: LoadingComponent
})
let AsyncForm = loadable({
  loader: () => import('../routes/form/'),
  loading: LoadingComponent
})
let AsyncPage = loadable({
  loader: () => import('../routes/page/'),
  loading: LoadingComponent
})
let AsyncPageLayout = loadable({
  loader: () => import('../routes/page-layout/'),
  loading: LoadingComponent
})
let AsyncTable = loadable({
  loader: () => import('../routes/table/'),
  loading: LoadingComponent
})
let AsyncUI = loadable({
  loader: () => import('../routes/ui/'),
  loading: LoadingComponent
})


class MainApp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }

    

    window.addEventListener('err_dialog', (err) => {
      console.log(err);
      this.setState({
        dialog: {
          open: true,
          head: 'Error',
          body: err.detail.message,
          actions: [
            <FlatButton
              label="Okay"
              primary
              onClick={this.closeDialog.bind(this)}
            />
          ]
        }
      })
    })
    window.addEventListener('success_dialog', (err) => {

      this.setState({
        dialog: {
          open: true,
          head: 'Success',
          body: err.detail.message,
          actions: [
            <FlatButton
              label="Okay"
              primary
              onClick={this.closeDialog.bind(this)}
            />
          ]
        }
      })
    })
  }

  componentWillReceiveProps() {
    store.dispatch(toggleLoader(false));
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })

  }

  componentWillMount() {
    _mqtt.connect(APPCONFIG.mqttUser, APPCONFIG.mqttPass,1);
    this.getPartnerDetails();
    let user = ls.getUserDetails();
    if(user && user.hotel && user.hotel.onesignal){
      console.log("Here!!!");
      var OneSignal = window.OneSignal || [];
      OneSignal.push(function () {
        OneSignal.init({
        appId: user.hotel.onesignal.app_id,//"23fd980c-9125-45a4-a160-28f55c69b430",
        safari_web_id: user.hotel.onesignal.safari_web_id,//"web.onesignal.auto.55479a10-4eda-4299-901a-290da3fd1836",
        notifyButton: {
          enable: true,
        },
        allowLocalhostAsSecureOrigin: true,
      });
      OneSignal.setExternalUserId(user.id);
      });
    }
  }

  getPartnerDetails() {
    if (ls.getPartner()) {
      ds.getPartnerDetails(data => {
        if (data && data.hospitality_portal) {
          ls.setPartnerDetails(data);
        }
      }, err => { })
    }
  }

  render() {
    const { match, location, authenticated } = this.props;

    return (
      <div className="main-app-container">
        <Sidenav authenticated={authenticated} />
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>

        <section id="page-container" className="app-page-container">
          <Header />

          <div className="app-content-wrapper">
            <div className="app-content">
              <div className="full-height">
                <Route path={`${match.url}/dashboard`} render={() => { return (<Dashboard authenticated={authenticated} />) }} />
                <Route path={`${match.url}/rooms/list`} render={() => { return (<Rooms authenticated={authenticated} />) }} />
                <Route path={`${match.url}/rooms/consolidated`} render={() => { return (<ConsolidatedRooms authenticated={authenticated} />) }} />
                <Route path={`${match.url}/rooms/control/:id`} render={(props) => { return (<RoomControl authenticated={authenticated} {...props} />) }} />
                <Route path={`${match.url}/rooms/configure/:id`} render={(props) => { return (<DeviceConfigure authenticated={authenticated} {...props} />) }} />
                <Route path={`${match.url}/rooms/pair_lock/:id`} render={(props) => { return (<LockPair authenticated={authenticated} {...props} />) }} />
                <Route path={`${match.url}/rooms/post_actions/:id`} render={(props) => { return (<ActionsPost authenticated={authenticated} {...props} />) }} />
                <Route path={`${match.url}/stats/checkin`} render={() => { return (<RoomStats authenticated={authenticated} />) }} />
                <Route path={`${match.url}/stats/lockHistory`} render={() => { return (<LockStats authenticated={authenticated} />) }} />
                <Route path={`${match.url}/stats/power`} render={() => { return (<PowerRoute authenticated={authenticated} />) }} />
                <Route path={`${match.url}/directory`} render={() => { return (<TelephoneDirectory authenticated={authenticated} />) }} />
                <Route path={`${match.url}/wifi`} render={() => { return (<WifiManagement authenticated={authenticated} />) }} />
                <Route path={`${match.url}/food`} render={() => { return (<FoodMenu authenticated={authenticated} />) }} />
                <Route path={`${match.url}/movelock`} render={() => { return (<Lock authenticated={authenticated} />) }} />
                <Route path={`${match.url}/services/requests/:name`} render={(props) => { return (<ServiceRequests authenticated={authenticated} {...props}/>) }} />
                {/* <Route path={`${match.url}/services/alerts`} render={() => { return (<IntrusionAlets authenticated={authenticated} />)}} /> */}
                <Route path={`${match.url}/services/manage`} render={() => { return (<ManageServices authenticated={authenticated} crud={false} />) }} />
                <Route path={`${match.url}/services/crud`} render={() => { return (<ManageServices authenticated={authenticated} crud={true} />) }} />
                <Route path={`${match.url}/services/btn`} render={() => { return (<ManageServiceButtons authenticated={authenticated} />) }} />
                <Route path={`${match.url}/users`} render={() => { return (<Users authenticated={authenticated} />) }} />
                <Route path={`${match.url}/smartlockcards`} render={() => { return (<SmartLockCards authenticated={authenticated} />) }} />
                <Route path={`${match.url}/promos`} render={() => { return (<Promotions authenticated={authenticated} />) }} />
                <Route path={`${match.url}/feedback/templates/create`} render={() => { return (<FeedbackTemplatesCreate authenticated={authenticated} />) }} />
                <Route path={`${match.url}/feedback/templates/list`} render={() => { return (<FeedbackTemplatesView authenticated={authenticated} />) }} />
                <Route path={`${match.url}/feedback/template/responses/:id`} render={(props) => { return (<FeedbackResponse authenticated={authenticated} {...props} />) }} />
                <Route path={`${match.url}/integration/generateToken`} render={() => { return (<GenerateToken authenticated={authenticated} />) }} />
                <Route path={`${match.url}/schedule`} render={() => { return (<Schedule authenticated={authenticated} />) }} />
                {/* <Route path={`${match.url}/settings`} render={() => { return (<Settings authenticated={authenticated} />)}} /> */}
                {/* <Route path={`${match.url}/chart`} component={AsyncChart} />
                  <Route path={`${match.url}/ecommerce`} component={AsyncECommerce} />
                  <Route path={`${match.url}/form`} component={AsyncForm} />
                  <Route path={`${match.url}/page`} component={AsyncPage} />
                  <Route path={`${match.url}/pglayout`} component={AsyncPageLayout} />
                  <Route path={`${match.url}/table`} component={AsyncTable} />
                  <Route path={`${match.url}/ui`} component={AsyncUI} /> */}
              </div>
            </div>

            <Footer />
          </div>
        </section>

        {/* <Customizer /> */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authenticated: state.auth
});

module.exports = connect(mapStateToProps)(MainApp);



// WEBPACK FOOTER //
// ./routes/app/components/MainApp.js